<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-btn
        v-if="history.length > 1"
        color="gray-6"
        class="ml-0"
        icon
        flat
        @click="goBack"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ $t(`${namespace}.title`) }}
      </v-flex>
    </v-layout>

    <div>
      <v-btn
        color="gray-6"
        class="mx-0"
        icon
        flat
        @click="close"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.voucher.header'
    }
  },
  methods: {
    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    }
  }
}
</script>
